import { Shield, Eye, Lock, UserX, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import SEO from '@/components/SEO';

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-blue-50 to-cyan-50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900">
      <SEO
        title="Privacy Policy — Toonah"
        description="Toonah's privacy policy: how anonymous video conversations stay ephemeral, what we do and do not store, and your rights."
        path="/privacy"
      />
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 glass-card">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <button onClick={() => navigate('/')} className="text-2xl font-black">← Toonah</button>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20">
        <div className="glass-card p-8 md:p-12 rounded-3xl">
          <div className="flex items-center space-x-4 mb-8">
            <Shield className="w-12 h-12 text-blue-600" />
            <h1 className="text-4xl font-black">Privacy Policy</h1>
          </div>

          <div className="space-y-8 text-slate-700 dark:text-slate-300">
            <section>
              <h2 className="text-2xl font-bold mb-4 flex items-center space-x-2">
                <Eye className="w-6 h-6 text-blue-600" />
                <span>What We See</span>
              </h2>
              <p className="leading-relaxed">
                Toonah connects you with random people through live video and audio. We do <strong>not permanently store</strong> your video or audio streams. All conversations are live and temporary.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 flex items-center space-x-2">
                <UserX className="w-6 h-6 text-blue-600" />
                <span>No Registration Required</span>
              </h2>
              <p className="leading-relaxed">
                You don't need to create an account or provide any personal information. We generate temporary anonymous session IDs that exist only during your visit.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 flex items-center space-x-2">
                <Lock className="w-6 h-6 text-blue-600" />
                <span>Technical Logs</span>
              </h2>
              <p className="leading-relaxed">
                For debugging and improving service quality, we may collect temporary technical logs including connection times, session IDs, and browser information. These logs do not contain your personal conversations.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4 flex items-center space-x-2">
                <AlertCircle className="w-6 h-6 text-red-600" />
                <span>Your Safety</span>
              </h2>
              <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-6">
                <p className="font-semibold text-red-900 dark:text-red-200 mb-2">Never share:</p>
                <ul className="list-disc list-inside space-y-1 text-red-800 dark:text-red-300">
                  <li>Passwords or OTPs</li>
                  <li>Banking or financial information</li>
                  <li>Your exact location or address</li>
                  <li>Anything that makes you uncomfortable</li>
                </ul>
              </div>
            </section>

            <section className="pt-6 border-t border-slate-200 dark:border-slate-700">
              <p className="text-sm text-slate-500">
                Last updated: January 2026
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;